/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Draft_Discard_ConfirmInputs */

const en_us2_draft_discard_confirm = /** @type {(inputs: Draft_Discard_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Discard draft`)
};

const pt_br2_draft_discard_confirm = /** @type {(inputs: Draft_Discard_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descartar rascunho`)
};

const es_419_draft_discard_confirm = /** @type {(inputs: Draft_Discard_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descartar borrador`)
};

const pt_pt2_draft_discard_confirm = /** @type {(inputs: Draft_Discard_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descartar rascunho`)
};

const fr_fr2_draft_discard_confirm = /** @type {(inputs: Draft_Discard_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abandonner le brouillon`)
};

const de_de2_draft_discard_confirm = /** @type {(inputs: Draft_Discard_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entwurf verwerfen`)
};

const it_it2_draft_discard_confirm = /** @type {(inputs: Draft_Discard_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scarta bozza`)
};

/**
* | output |
* | --- |
* | "Discard draft" |
*
* @param {Draft_Discard_ConfirmInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const draft_discard_confirm = /** @type {((inputs?: Draft_Discard_ConfirmInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Draft_Discard_ConfirmInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_draft_discard_confirm(inputs)
	if (locale === "es-419") return es_419_draft_discard_confirm(inputs)
	if (locale === "pt-PT") return pt_pt2_draft_discard_confirm(inputs)
	if (locale === "fr-FR") return fr_fr2_draft_discard_confirm(inputs)
	if (locale === "de-DE") return de_de2_draft_discard_confirm(inputs)
	if (locale === "it-IT") return it_it2_draft_discard_confirm(inputs)
	return en_us2_draft_discard_confirm(inputs)
});
export { draft_discard_confirm as "draft.discard_confirm" }